// extracted by mini-css-extract-plugin
module.exports = {"partnerListWrapper":"_2eZjj","collapsedPartnerList":"_18d_z","partnerList":"_2SM-R","listTitle":"_3aBQU","partnerListTitle":"OEa90"};